import { TextField } from '@mui/material';
import Button from '@restart/ui/esm/Button';
import React, { useState } from 'react';
import { Alert } from 'react-bootstrap';
import useAuth from '../../../../hooks/useAuth';

const MakeAdmin = () => {
    const [email, setEmail] = useState('');
    const [success, setSuccess] = useState(false);

    const handleOnBlur = e => {
        setEmail(e.target.value);
    }

    // make admin
    const handleAdminSubmit = e => {
        const user = { email };
        fetch('https://peaceful-hollows-15689.herokuapp.com/users/admin', {
            method: 'PUT',
            headers: {

                'content-type': 'application/json'
            },
            body: JSON.stringify(user)
        })
            .then(res => res.json())
            .then(data => {
                console.log(data)
                if (data.modifiedCount > 0) {
                    setEmail('')
                    setSuccess(true);
                }
            })

        e.preventDefault()
    }

    //take new admin email
    return (

        <div>
            <h2>Make an Admin</h2>
            <form className="my-4" onSubmit={handleAdminSubmit}>
                <TextField

                    sx={{ width: '50%' }}
                    label="Email"
                    type="email"
                    onBlur={handleOnBlur}
                    variant="standard" /><br /><br /><br />
                <Button type="submit" className="btn btn-primary p-3 px-5">Make Admin</Button>
            </form>
            {success && <Alert severity="success">Made Admin successfully!</Alert>}
        </div>
    );
};

export default MakeAdmin;